import { IEntityTypePayload } from '../entity-data/entity-data.actions';
import { List } from 'immutable';
import { EntityTypesEnum } from '../../app.enum';

// action payload interfaces
export interface ISetCategoriesPayload extends IEntityTypePayload {
  categories: List<string>;
}

// action enums
export enum ActionsEnum {
  SET_CATEGORIES = 'SET_CATEGORIES',
}

// action definitions
export interface SetCategories {
  type: ActionsEnum.SET_CATEGORIES;
  payload: ISetCategoriesPayload;
}

export const setCategories = (
  entityType: EntityTypesEnum,
  categories: List<string>
): SetCategories => ({
  type: ActionsEnum.SET_CATEGORIES,
  payload: {
    entityType,
    categories,
  },
});
